import dayjs from 'dayjs';
import React from 'react';

import { Button } from 'src/components/ui/button';
import { ButtonGroup } from 'src/components/ui/button-group';

export type DateRangePresetsValue = 'yesterday' | 'today' | 'week' | 'month' | 'year';

export interface DateRangePresetsProps {
  defaultValue?: DateRangePresetsValue;
  value?: DateRangePresetsValue | null;
  onChange?: (value: DateRangePresetsValue) => void;
}

/**
 * 根据预设值获取日期范围
 * @param preset 预设值
 * @returns 日期范围 [开始日期, 结束日期]
 */
export function getDateRangeFromPreset(preset: DateRangePresetsValue): [Date, Date] {
  switch (preset) {
    case 'yesterday':
      return [
        dayjs().subtract(1, 'day').startOf('day').toDate(),
        dayjs().subtract(1, 'day').endOf('day').toDate(),
      ];
    case 'today':
      return [dayjs().startOf('day').toDate(), dayjs().endOf('day').toDate()];
    case 'week':
      return [dayjs().startOf('week').toDate(), dayjs().endOf('day').toDate()];
    case 'month':
      return [dayjs().startOf('month').toDate(), dayjs().endOf('day').toDate()];
    case 'year':
      return [dayjs().startOf('year').toDate(), dayjs().endOf('day').toDate()];
  }
}

export function DateRangePresets({ defaultValue, value, onChange }: DateRangePresetsProps) {
  const activeClass = 'border-primary text-primary !border !border-l';
  const currentValue = value === undefined ? defaultValue : value;

  return (
    <ButtonGroup>
      <Button
        variant="outline"
        size="sm"
        className={currentValue === 'yesterday' ? activeClass : ''}
        onClick={() => onChange?.('yesterday')}
      >
        昨日
      </Button>

      <Button
        variant="outline"
        size="sm"
        className={currentValue === 'today' ? activeClass : ''}
        onClick={() => onChange?.('today')}
      >
        今日
      </Button>

      <Button
        variant="outline"
        size="sm"
        className={currentValue === 'week' ? activeClass : ''}
        onClick={() => onChange?.('week')}
      >
        本周
      </Button>

      <Button
        variant="outline"
        size="sm"
        className={currentValue === 'month' ? activeClass : ''}
        onClick={() => onChange?.('month')}
      >
        本月
      </Button>

      <Button
        variant="outline"
        size="sm"
        className={currentValue === 'year' ? activeClass : ''}
        onClick={() => onChange?.('year')}
      >
        今年
      </Button>
    </ButtonGroup>
  );
}

export default DateRangePresets;
